<template>
  <div class="Download">
    <div class="content">
        <div class="logo"><img src="../assets/images/img_logo_v2.png" alt=""></div>
        <p class="text" v-html="pageType"></p>
        <div class='download-btn' v-clipboard:copy="downloadHref" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ btnText }}</div>
    </div>
    <div class="popbox" v-if="toastApp" @click="toastApp = !toastApp">
      <div class="popbox-content">
        <div class="popbox-title">下载 MyChevy APP</div>
        <ul class="popbox-text">
            <li>
                <img class="va-center" src="../assets/images/icon-right@2x.png" alt="">
                <p class="va-center right">您可前往应用商店搜索下载</p>
            </li>
            <li class="popbox-text-2">
                <img class="va-center" src="../assets/images/icon-right@2x.png" alt="">
                <p class="va-center right">或到手机自带浏览器打开已复制的链接</p>
            </li>
        </ul>
        <div class="popbox-btn" @click='closeToastApp'>我知道了</div>
      </div>
    </div>
    <div v-if='alertMes' class="alertMes" v-html='alertMes'></div>
  </div>
</template>

<script>
    export default {
        name: "CallApp",
        data(){
            return {
                downloadHref: "",
                toastApp: false,
                alertMes: "",
                page: this.$route.query.pageType,
                btnText: "前往下载",
            }
        },
        created(){
            let href = "https://mychevyh5.cw.sgmlink.com/landing?channel=" + this.$route.query.channel || ''
            if(this.$route.query.inforDetail){
                href = href+'&inforDetail=' + this.$route.query.inforDetail
            }
            this.downloadHref = href;
            document.title = this.$route.query.title || "MyChevy App 全新上线"
        },
        methods: {
            onCopy () {
                this.toastApp = true
            },
            onError () {
                this.alertMesFn('链接复制失败,请重试')
            },
            closeToastApp(){
                this.toastApp = false
                this.alertMesFn('链接已复制<br/>可打开浏览器下载')
            },
            alertMesFn(mes){
                this.alertMes = mes
                setTimeout(()=>{
                    this.alertMes = ""
                },1000)
            }
        },
        computed:{
            pageType(){
                let str = ""
                switch (this.page){
                    case "myCar":
                        str = "请前往下载MyChevy APP<br/>添加或解绑车辆";
                        break;
                    case "share":
                        str = "请前往下载MyChevy APP<br/>认识更多志同道合的朋友";
                        break;
                    case "joinMember":
                        str = "请下载MyChevy APP并注册会员<br/>探索无限精彩";
                        break;
                    case "billing2021":
                        str = "前往MyChevy APP<br/>查看300万车主的年度报告";
                        break;
                    default:
                        str = "请前往下载MyChevy APP<br/>探索无限精彩";
                }
                return str;
            }
        }
    }
</script>

<style lang="less" scoped>
    .Download {
        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100vh;
            text-align: center;
            margin-top: -40px;
            .logo {
                img {
                    width: 80px;
                }
            }
            .text {
                font-family: PingFangSC, PingFangSC-Regular;
                font-size: 16px;
                font-weight: 400;
                color: #383938;
                line-height: 26px;
                margin-top: 30px;
            }
            .download-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
                width: 200px;
                height: 40px;
                background: #b6862d;
                border-radius: 1px;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #fff;
            }
        }
        .popbox{
            position:fixed;
            top:0;
            left:0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.75);
            .popbox-content {
                position:absolute;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                width: 280px;
                background: #ffffff;
                border-radius: 12px;    
                text-align: center;
            }
            .popbox-title {
                padding-top: 24px;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #808080;
            }
            .popbox-text {
                width: 235px;
                margin: 10px auto 0;
                text-align: left;
                margin-top: 10px;
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #303030;
                .popbox-text-2 {
                    margin-top: 8px;
                }
                .right {
                    margin-left: 22px;
                }
                li {
                    position: relative;
                }
                img {
                    position: absolute;
                    left: 0;
                    top: 2px;
                    width: 18px;
                    margin-right: 4px;
                }
            }
            .popbox-btn {
                margin-top: 16px;
                border-top: 1px solid #ccc;
                height: 50px;
                line-height: 50px;
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                color: #00a5e1;
            }
        }
    }
    .va-center { vertical-align: middle; }
    .alertMes{
        position:fixed;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width: 176px;
        padding: 13px;
        background: rgba(0,0,0,0.75);
        border-radius: 10px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 22px;
    }
</style>
